const WISTIA_CONFIG = {
  EMBED_SCRIPT_URL: "https://fast.wistia.com/assets/external/E-v1.js",
  OEMBED_API_BASE: "https://fast.wistia.com/oembed",
  MEDIA_BASE_URL: "https://home.wistia.com/medias",
  DEFAULT_ASPECT_RATIO: 16 / 9
} as const;

export default WISTIA_CONFIG;
